import { render, staticRenderFns } from "./HisDeal.vue?vue&type=template&id=7ca2dea0&scoped=true"
import script from "./HisDeal.vue?vue&type=script&lang=js"
export * from "./HisDeal.vue?vue&type=script&lang=js"
import style0 from "./HisDeal.vue?vue&type=style&index=0&id=7ca2dea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca2dea0",
  null
  
)

export default component.exports